export default __webpack_public_path__ + "static/media/face-1.e7967983.svg";